<div class="min-vh-100 entity-config-detail-page">
  <div class="d-flex flex-column gap-4 gap-lg-3 mx-auto">
    <section class="entity-config-top rounded-top-4 overflow-hidden border-0">
      <div class="entity-config-top-hero p-2">
        <div class="row g-2 align-items-start flex-nowrap">
          <div class="col">
            <h1 class="entity-page-title text-white fw-bold lh-sm mb-1">Manage Child Entities</h1>
            <p class="entity-page-subtitle text-white mb-0">
              Review hierarchy and manage requirements for child entities
            </p>
          </div>

          <div class="col-auto d-flex justify-content-end">
            
          </div>
        </div>
      </div>

      <div class="px-2 px-md-3 pb-3">
        <section class="row g-2 entity-config-top-metrics">
          <div
            v-for="metric in hero_metrics"
            :key="metric.label"
            class="col-12 col-md-6 mt-2"
          >
            <article class="entity-metric-card h-100 rounded-4 border shadow-sm p-3">
              <div class="d-flex align-items-start justify-content-between gap-3">
                <div class="d-flex flex-column justify-content-start pt-1 ps-2">
                  <span class="entity-metric-label secondary-color text-uppercase fw-bold d-block mb-2">
                    {{ metric.label }}
                  </span>
                  <div class="entity-metric-value secondary-color fw-bold lh-1 mb-0 mt-1">{{ metric.value }}</div>
                </div>

                <div class="entity-metric-icon rounded-3 d-inline-flex align-items-center justify-content-center mt-2 me-1 text-white" :class="`metric-icon-${metric.tone}`">
                  <i class="bi" :class="metric.icon"></i>
                </div>
              </div>
            </article>
          </div>
        </section>
      </div>
    </section>

    <section class="entity-inventory-panel rounded-4 border shadow-sm p-2">
      <div class="row g-2 align-items-start align-items-lg-center mb-3">
        <div class="col-12 col-lg">
          <div class="d-flex align-items-center gap-3">
            <div class="entity-section-icon rounded-3 d-inline-flex align-items-center justify-content-center">
              <i class="bi bi-diagram-3-fill"></i>
            </div>
            <div>
              <div class="entity-section-title fw-bold fs-6">All Entities and Child Entities</div>
              <div class="small text-secondary">Structured hierarchy with connected row-level relationships.</div>
            </div>
          </div>
        </div>
      </div>

      <div class="entity-table-head secondary-color d-none d-lg-block rounded-3 mb-2 px-3 py-2 text-uppercase tracking-wide">
        <div class="row g-2 align-items-center">
          <div class="col-auto d-flex align-items-center justify-content-center" aria-hidden="true">
            <span class="entity-row-arrow rounded-circle d-inline-flex align-items-center justify-content-center opacity-0">
              <i class="bi bi-chevron-right"></i>
            </span>
          </div>
          <div class="col-lg-4">Entity Name</div>
          <div class="col-lg-2">Type</div>
          <div class="col-lg-2">Direct Children</div>
          <div class="col-lg-3 text-end">Actions</div>
        </div>
      </div>

      <div v-if="loading" class="d-flex align-items-center gap-2 text-secondary text-xs py-2">
        <div class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div>
        <span>Loading entities...</span>
      </div>

      <div v-else-if="load_error" class="card border-0 shadow-sm rounded-4">
        <div class="card-body p-4 small text-danger">
          {{ load_error }}
        </div>
      </div>

      <div v-else-if="!hierarchy_cards.length" class="card border-0 shadow-sm rounded-4">
        <div class="card-body p-4 small text-secondary">
          No entities found yet.
        </div>
      </div>

      <section
        v-for="card in hierarchy_cards"
        :key="card.id"
        class="d-flex flex-column gap-2 mt-2"
      >
        <article class="entity-row-card bg-white rounded-4 border shadow-sm p-2">
          <div class="row g-2 align-items-center">
            <div class="col-auto">
              <button
                type="button"
                class="entity-row-arrow rounded-circle d-inline-flex align-items-center justify-content-center"
                aria-label="Toggle entity card"
                @click="toggle_card(card.id)"
              >
                <i class="bi" :class="card.expanded ? 'bi-chevron-down' : 'bi-chevron-right'"></i>
              </button>
            </div>

            <div class="col-12 col-lg-4 d-flex align-items-start align-items-sm-center gap-3">
              <div
                class="entity-type-icon entity-icon-surface rounded-3 d-inline-flex align-items-center justify-content-center"
                :class="`entity-icon-${card.tone || 'slate'}`"
              >
                <i class="bi" :class="card.icon"></i>
              </div>
              <div class="min-w-0">
                <div class="entity-name fw-bold">{{ card.name }}</div>
                <div class="entity-updated small">{{ card.subtitle }}</div>
              </div>
            </div>

            <div class="col-12 col-sm-4 col-lg-2">
              <span class="entity-status-pill entity-status-active d-inline-flex align-items-center justify-content-center fw-bold text-uppercase">
                {{ card.type_label }}
              </span>
            </div>

            <div class="col-12 col-sm-5 col-lg-2 small text-secondary">
              <i class="bi bi-diagram-3 me-2"></i>
              {{ card.child_summary }}
            </div>

            <div class="col-12 col-sm-3 col-lg-3 d-flex justify-content-lg-end align-items-center">
              <div class="d-flex justify-content-lg-end align-items-center gap-2 w-100">
              <button
                type="button"
                class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1"
                @click="go_to_child_requirements(card)"
              >
                <i class="bi bi-ui-checks-grid me-2"></i>
                <span>View Child Requirements</span>
              </button>
              <button
                type="button"
                class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1"
                data-bs-toggle="modal"
                data-bs-target="#manage_add_child_modal"
                @click="add_sub_entity(card)"
              >
                <i class="bi bi-plus-circle-fill me-2"></i>
                <span>Add Child Entity</span>
              </button>
              </div>
            </div>
          </div>
        </article>

        <div v-if="card.expanded && card.children.length" class="hierarchy-stack">
          <div
            v-for="(child, child_index) in card.children"
            :key="child.id"
            class="hierarchy-item"
          >
            <div class="hierarchy-rail">
              <span class="hierarchy-branch"></span>
            </div>

            <div class="flex-grow-1">
              <article
                class="entity-row-card rounded-4 border shadow-sm p-2"
                :class="child.tone === 'highlight' ? 'entity-inventory-panel' : 'bg-white'"
              >
                <div class="row g-2 align-items-center">
                  <div class="col-12 col-lg-5 d-flex align-items-start align-items-sm-center gap-3">
                    <div
                      class="entity-type-icon entity-icon-surface rounded-3 d-inline-flex align-items-center justify-content-center flex-shrink-0"
                      :class="`entity-icon-${child.tone || 'slate'}`"
                    >
                      <i class="bi" :class="child.icon"></i>
                    </div>
                    <div class="min-w-0">
                      <div class="entity-name fw-bold">{{ child.name }}</div>
                      <div v-if="child.subtitle" class="entity-updated small">{{ child.subtitle }}</div>
                    </div>
                  </div>

                  <div class="col-12 col-sm-4 col-lg-2">
                    <span
                      class="entity-status-pill d-inline-flex align-items-center justify-content-center fw-bold text-uppercase"
                      :class="child.tone === 'highlight' ? 'entity-status-review' : 'entity-status-active'"
                    >
                      {{ child.type_label }}
                    </span>
                  </div>

                  <div class="col-12 col-sm-5 col-lg-3 small text-secondary d-flex align-items-center gap-2 flex-wrap">
                    <template v-if="child.avatar_stack">
                      <div class="d-flex align-items-center">
                        <span
                          v-for="(avatar, avatar_index) in child.avatar_stack"
                          :key="`${child.id}-${avatar_index}`"
                          class="entity-avatar-dot rounded-circle border border-2 border-white d-inline-block"
                          :class="{ 'entity-avatar-dot-overlap': avatar_index }"
                          :style="{ '--entity-avatar-bg': avatar }"
                        ></span>
                      </div>
                    </template>
                    <template v-else>
                      <span>{{ child.child_summary }}</span>
                    </template>
                  </div>

                  <div class="col-12 col-sm-3 col-lg-2 d-flex justify-content-lg-end align-items-center gap-2 flex-wrap">
                    <button
                      type="button"
                      class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1"
                      data-bs-toggle="modal"
                      data-bs-target="#manage_child_requirement_modal"
                      @click="open_requirement_modal(child, child_index, card)"
                    >
                      {{ child.has_requirement ? 'Create Another Requirement' : 'Create Requirement' }}
                    </button>

                    <button
                      type="button"
                      class="btn btn-link btn-sm p-0 text-dark text-decoration-none"
                      :disabled="unbinding_child_key === `${card.id}-${child.id}`"
                      @click="confirm_unassign_child(card, child)"
                    >
                      <span
                        v-if="unbinding_child_key === `${card.id}-${child.id}`"
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <i
                        v-else
                        class="bi bi-x-lg"
                        aria-hidden="true"
                      ></i>
                    </button>

                    <button
                      v-if="child.expandable"
                      type="button"
                      class="entity-row-arrow rounded-circle d-inline-flex align-items-center justify-content-center"
                      aria-label="Toggle child row"
                      @click="toggle_child(card.id, child.id)"
                    >
                      <i class="bi" :class="child.expanded ? 'bi-dash-circle' : (child.action_icon || 'bi-plus-circle')"></i>
                    </button>
                  </div>
                </div>

                <div v-if="child.has_requirement" class="small text-secondary mt-2">
                  Requirement: {{ child.requirement_display_name || child.name }}
                  <span v-if="child.requirement_summary">({{ child.requirement_summary }})</span>
                </div>
              </article>

              <div v-if="child.expandable && child.expanded" class="hierarchy-stack hierarchy-stack-deep mt-2">
                <div
                  v-for="grandchild in child.grandchildren"
                  :key="grandchild.id"
                  class="hierarchy-item"
                >
                  <div class="hierarchy-rail hierarchy-rail-deep">
                    <span class="hierarchy-branch"></span>
                  </div>

                  <article class="entity-row-card bg-white rounded-4 border shadow-sm p-2 flex-grow-1">
                    <div class="row g-2 align-items-center">
                      <div class="col-12 col-lg d-flex align-items-center gap-2">
                        <i class="bi small text-secondary" :class="grandchild.icon"></i>
                        <span class="small fw-semibold text-dark">{{ grandchild.name }}</span>
                      </div>
                      <div class="col-12 col-lg-auto text-lg-end">
                        <span
                          class="small fw-bold"
                          :class="grandchild.status_tone === 'success' ? 'text-success' : 'text-danger'"
                        >
                          {{ grandchild.status_label }}
                        </span>
                      </div>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="card.expanded" class="card border-0 shadow-sm rounded-4">
          <div class="card-body p-3 small text-secondary">
            No child entities assigned yet.
          </div>
        </div>
      </section>
    </section>
  </div>

  <teleport to="body">
    <div
      class="modal fade"
      id="manage_add_child_modal"
      tabindex="-1"
      aria-labelledby="manage_add_child_modal_label"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-white rounded-4 p-0 shadow-lg">
          <div class="modal-header border-bottom-0 cute-header shadow-lg">
            <div>
              <p class="modal-title text-white text-xxs mb-0" id="manage_add_child_modal_label">Add Child Entity</p>
              <div class="small text-white-50 mt-1">
                {{ active_add_child_parent?.name || 'Current parent entity' }}
              </div>
            </div>
            <button
              type="button"
              class="modal-btn-close btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              :disabled="binding_sub_entity"
            ></button>
          </div>

          <div class="modal-body">
            <div class="modal-form-group form-group mb-3">
              <label class="modal-form-label form-label text-xxs">Select Child Entity</label>
              <select
                v-model="selected_sub_entity_id"
                class="modal-form-control form-select text-xs rounded-small p-2 shadow-sm text-x"
                :disabled="sub_entities_loading || binding_sub_entity"
              >
                <option value="">
                  {{ sub_entities_loading ? 'Loading entity types...' : 'Select an entity type to bind' }}
                </option>
                <option
                  v-for="item in bindable_sub_entities"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.name }}
                </option>
              </select>
            </div>

            <div class="small text-secondary">
              Note: child entities help model hierarchy, ownership, and dependency relationships.
            </div>
          </div>

          <div class="modal-footer border-0 p-3 d-flex justify-content-end gap-2">
            <button
              type="button"
              class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1 text-white"
              :disabled="!selected_sub_entity_id || binding_sub_entity || sub_entities_loading"
              @click="bind_sub_entity"
            >
              {{ binding_sub_entity ? 'Binding...' : 'Bind Child' }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="manage_child_requirement_modal"
      tabindex="-1"
      aria-labelledby="manage_child_requirement_modal_label"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-white rounded-4 p-0 shadow-lg">
          <div class="modal-header border-bottom-0 cute-header shadow-lg">
            <div>
              <p class="modal-title text-white text-xxs mb-0" id="manage_child_requirement_modal_label">Create Child Requirement</p>
              <div class="small text-white-50 mt-1">
                {{ active_requirement_parent?.name || 'Current parent entity' }} / {{ active_requirement_binding?.name || 'Selected child entity' }}
              </div>
            </div>
            <button
              type="button"
              class="modal-btn-close btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              :disabled="creating_requirement"
            ></button>
          </div>

          <div class="modal-body">
            <div class="modal-form-group form-group mb-3">
              <label class="modal-form-label form-label text-xxs">Display Name</label>
              <input
                v-model.trim="requirement_form.display_name"
                type="text"
                class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-x"
                placeholder="Enter requirement display name"
              />
            </div>

            <div class="row g-3">
              <div class="col-12 col-md-6">
                <label class="modal-form-label form-label text-xxs">Minimum Count</label>
                <input
                  v-model.number="requirement_form.min_count"
                  type="number"
                  min="0"
                  class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-x"
                />
              </div>

              <div class="col-12 col-md-6">
                <label class="modal-form-label form-label text-xxs">Maximum Count</label>
                <input
                  v-model.trim="requirement_form.max_count"
                  type="number"
                  min="0"
                  class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-x"
                  placeholder="Leave blank for no maximum"
                />
                <div class="form-text text-xxs">Leave blank for no maximum.</div>
              </div>

              <div class="col-12 col-md-6">
                <label class="modal-form-label form-label text-xxs">Onboarding Mode</label>
                <select
                  v-model="requirement_form.onboarding_mode"
                  class="modal-form-control form-select text-xs rounded-small p-2 shadow-sm text-x"
                >
                  <option value="manual">Manual</option>
                  <option value="self_service">Self Service</option>
                </select>
              </div>

              <div class="col-12 col-md-6">
                <label class="modal-form-label form-label text-xxs">Display Order</label>
                <input
                  v-model.number="requirement_form.display_order"
                  type="number"
                  min="0"
                  class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-x"
                />
              </div>
            </div>

            <div class="form-check form-switch mt-3">
              <input
                id="manage-child-requirement-required"
                v-model="requirement_form.is_required_for_completion"
                class="form-check-input"
                type="checkbox"
              />
              <label class="form-check-label small" for="manage-child-requirement-required">
                Required for completion
              </label>
            </div>
          </div>

          <div class="modal-footer border-0 p-3 d-flex justify-content-end gap-2">
            <button
              type="button"
              class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1 text-white"
              :disabled="creating_requirement"
              @click="create_requirement"
            >
              {{ creating_requirement ? 'Creating...' : 'Create Requirement' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</div>
